import { createPortal } from "react-dom";

import styles from './styles.module.scss'
import { useState } from "react";
import { useLocalStorage } from "@uidotdev/usehooks";

export function ModalAge() {
  const [hasAge, setHasAge] = useState(true)
  const [isOpenModal, setIsOpenModal] = useLocalStorage("@user:age:modal", true)

  if (!isOpenModal) return null

  return createPortal(
    <div className={styles.layer}>
      <div className={styles.container}>
        <img
          src="/assets/logo.png"
        />
        {
          hasAge ? (
            <>
              <div>
                <h3>Bem-Vindo ao SORTELEC DIGITAL!</h3>
                <p>Este site é destinado apenas a maiores de 18 anos.<br />Você tem 18 anos ou mais?</p>
              </div>
              <div>
                <button
                  onClick={() => setIsOpenModal(false)}
                >
                  Sim
                </button>
                <button
                  onClick={() => setHasAge(false)}
                >
                  Não
                </button>
              </div>
            </>
          ) : (
            <div>
              <h3>Desculpe, este site é destinado <br /> apenas a maiores de 18 anos.</h3>
            </div>
          )
        }

      </div>
    </div>,
    document.body
  )
}